import { useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import {
  startTourSetter,
  hasTourableNodesAtom,
  isTourOrExplanationRunningAtom,
} from "@zapier/canvas-state";
import { useComposerHandleSubmit } from "./useComposerHandleSubmit";

export function useStartTourFromQueryParams() {
  const searchParams = useSearchParams();
  const tourSearchParam = searchParams?.get("tour");
  const shouldStartTour = tourSearchParam === "true";
  const hasStartedTour = useRef(false);
  const startTour = useSetAtom(startTourSetter);
  const hasTourableNodes = useAtomValue(hasTourableNodesAtom);
  const isTourOrExplanationRunning = useAtomValue(
    isTourOrExplanationRunningAtom,
  );

  const composerHandleSubmit = useComposerHandleSubmit();

  useEffect(() => {
    if (
      shouldStartTour &&
      !hasStartedTour.current &&
      hasTourableNodes &&
      !isTourOrExplanationRunning
    ) {
      hasStartedTour.current = true;

      startTour({
        composerHandleSubmit,
      }).catch((error) => {
        console.error("Failed to start tour from query params:", error);
      });
    }
  }, [
    shouldStartTour,
    hasTourableNodes,
    isTourOrExplanationRunning,
    composerHandleSubmit,
    startTour,
  ]);
}
